/**
 * Vanilla JavaScript navbar functionality
 * Handles mobile menu toggle without Bootstrap
 */

document.addEventListener("DOMContentLoaded", function () {
  const navbarCollapse = document.getElementById("navbarNav");
  const navbarToggler = document.querySelector(".navbar-toggler");
  const navbar = document.querySelector(".navbar");

  if (navbarCollapse && navbarToggler && navbar) {
    // Toggle menu function
    function toggleMenu() {
      const isOpen = navbarCollapse.classList.contains("show");

      if (isOpen) {
        closeMenu();
      } else {
        openMenu();
      }
    }

    // Open menu function
    function openMenu() {
      navbarCollapse.classList.add("show");
      navbarToggler.setAttribute("aria-expanded", "true");
      navbar.classList.add("active");
      closeButton.style.display = "block";
    }

    // Close menu function
    function closeMenu() {
      navbarCollapse.classList.remove("show");
      navbarToggler.setAttribute("aria-expanded", "false");
      navbar.classList.remove("active");
      closeButton.style.display = "none";
    }

    // Handle burger button click and touch events
    let touchStarted = false;
    let lastAction = 0;

    function handleMenuToggle(e) {
      const now = Date.now();
      if (now - lastAction < 300) return; // Prevent double triggers

      e.preventDefault();
      e.stopPropagation();
      toggleMenu();
      lastAction = now;
    }

    navbarToggler.addEventListener(
      "touchstart",
      function (e) {
        touchStarted = true;
      },
      { passive: false },
    );

    navbarToggler.addEventListener(
      "touchend",
      function (e) {
        if (touchStarted) {
          handleMenuToggle(e);
          touchStarted = false;
        }
      },
      { passive: false },
    );

    navbarToggler.addEventListener("click", function (e) {
      if (!touchStarted) {
        handleMenuToggle(e);
      }
    });

    // Create close button
    const closeButton = document.createElement("button");
    closeButton.className = "navbar-close-btn";
    closeButton.setAttribute("aria-label", "Close navigation menu");
    closeButton.style.cssText = `
      position: absolute;
      top: 2rem;
      left: 2rem;
      width: 4rem;
      height: 4rem;
      background: transparent;
      border: none;
      cursor: pointer;
      z-index: 1052;
      display: none;
      touch-action: manipulation;
      -webkit-tap-highlight-color: transparent;
    `;

    // Add the close button to the navbar collapse
    navbarCollapse.appendChild(closeButton);

    // Handle close button click
    closeButton.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      closeMenu();
    });

    // MOBILE SUBMENU TOGGLE
    function initMobileSubmenus() {
      const dropdownToggles =
        navbarCollapse.querySelectorAll(".dropdown-toggle");

      dropdownToggles.forEach((toggle) => {
        // Créer le bouton toggle pour mobile
        const toggleBtn = document.createElement("button");
        toggleBtn.className = "mobile-submenu-toggle";
        toggleBtn.setAttribute("aria-label", "Toggle submenu");
        toggleBtn.innerHTML =
          '<svg width="22" height="12" viewBox="0 0 22 12" fill="none"><path d="M21 11L11 1L1 11" stroke="#002B5C" stroke-opacity="0.8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

        // Insérer le bouton après le lien
        toggle.parentElement.style.position = "relative";
        toggle.parentElement.appendChild(toggleBtn);

        // Empêcher le lien parent de naviguer EN MOBILE
        // toggle.addEventListener("click", function (e) {
        // 	if (window.innerWidth < 1200) {
        // 		// < bm__xl
        // 		e.preventDefault();
        // 		toggleSubmenu(this);
        // 	}
        // });

        // Le bouton toggle ouvre/ferme le sous-menu
        toggleBtn.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          toggleSubmenu(toggle);
        });
      });
    }

    function toggleSubmenu(toggleElement) {
      const submenu = toggleElement.nextElementSibling;
      const parentItem = toggleElement.parentElement;
      const toggleBtn = parentItem.querySelector(".mobile-submenu-toggle");

      if (submenu && submenu.classList.contains("dropdown-menu")) {
        const isOpen = submenu.classList.contains("show");

        // Fermer tous les autres sous-menus
        document.querySelectorAll(".dropdown-menu.show").forEach((menu) => {
          if (menu !== submenu) {
            menu.classList.remove("show");
            menu.parentElement.classList.remove("active");
            const otherBtn = menu.parentElement.querySelector(
              ".mobile-submenu-toggle",
            );
            if (otherBtn) otherBtn.classList.remove("active");
          }
        });

        // Toggle le sous-menu actuel
        if (isOpen) {
          submenu.classList.remove("show");
          parentItem.classList.remove("active");
          if (toggleBtn) toggleBtn.classList.remove("active");
        } else {
          submenu.classList.add("show");
          parentItem.classList.add("active");
          if (toggleBtn) toggleBtn.classList.add("active");
        }
      }
    }

    // init mobile submenu
    initMobileSubmenus();

    // Close menu when clicking on nav links (except dropdown-toggle)
    const navLinks = navbarCollapse.querySelectorAll(
      ".nav-link:not(.dropdown-toggle)",
    );
    navLinks.forEach((link) => {
      link.addEventListener("click", function () {
        // Close the menu after a small delay to allow navigation
        setTimeout(() => {
          closeMenu();
        }, 150);
      });
    });

    // Close menu when clicking outside
    document.addEventListener("click", function (e) {
      if (
        !navbar.contains(e.target) &&
        navbarCollapse.classList.contains("show")
      ) {
        closeMenu();
      }
    });
  }

  // NAVBAR SCROLL BEHAVIOR (hide on scroll down, show on scroll up)
  function initNavbarScroll() {
    const navbar = document.querySelector(".navbar");
    if (!navbar) return;

    let lastScrollY = window.scrollY;
    let ticking = false;
    const scrollThreshold = 100; // Start hiding after 100px scroll

    function updateNavbar() {
      const currentScrollY = window.scrollY;

      // Add/remove scrolled class for shadow effect
      if (currentScrollY > 10) {
        navbar.classList.add("scrolled");
      } else {
        navbar.classList.remove("scrolled");
      }

      // Only hide/show on desktop (>= 1200px)
      if (window.innerWidth >= 1200) {
        if (currentScrollY > scrollThreshold) {
          // Scrolling DOWN - hide navbar
          if (currentScrollY > lastScrollY) {
            navbar.classList.add("navbar-hidden");
          }
          // Scrolling UP - show navbar
          else {
            navbar.classList.remove("navbar-hidden");
          }
        } else {
          // Near top - always show
          navbar.classList.remove("navbar-hidden");
        }
      } else {
        // Mobile - always visible
        navbar.classList.remove("navbar-hidden");
      }

      lastScrollY = currentScrollY;
      ticking = false;
    }

    window.addEventListener("scroll", function () {
      if (!ticking) {
        window.requestAnimationFrame(updateNavbar);
        ticking = true;
      }
    });

    // Handle resize
    window.addEventListener("resize", function () {
      if (window.innerWidth < 1200) {
        navbar.classList.remove("navbar-hidden");
      }
    });
  }

  initNavbarScroll();
});
